const CLIENT_AR_ADMIN = {
    CREATED_BY_AR_ADMIN: {
        event: 'client_ar_admin_created_by_ar_admin',
        eventProperties: {
            description: 'Client AR Admin created a new Client AR Admin user',
        },
    },
    CLIENT_ADMIN_CREATED_BY_AR_ADMIN: {
        event: 'client_admin_created_by_ar_admin',
        eventProperties: {
            description: 'Client AR Admin created a new Client Admin user',
        },
    },
    ROLE_UPDATED_TO_AR_ADMIN: {
        event: 'client_ar_admin_role_updated_to_ar_admin',
        eventProperties: {
            description: 'Client AR Admin updated a user role to Client AR Admin',
        },
    },
    ROLE_UPDATED_TO_CLIENT_ADMIN: {
        event: 'client_ar_admin_role_updated_to_client_admin',
        eventProperties: {
            description: 'Client AR Admin updated a user role to Client Admin',
        },
    },
};

export default CLIENT_AR_ADMIN;
